import { createContext, useContext } from 'react';
import { myFilesApi } from '../api';

/**
 * Nơi khung xem trước xin URL đã ký — APM-PDOC-d.
 *
 * Trình xem chỉ biết URL (luật #3: nội dung đi thẳng S3 → trình duyệt), nhưng
 * **ai cấp URL** thì tuỳ tệp thuộc về đâu: tệp cá nhân qua `/me/files`, tệp dự
 * án qua `/files/:id/url` với quyền của dự án. Một context thay vì một prop đi
 * xuyên qua `PreviewBody` → `ViewerSlot` → trình xem → ảnh trong `.chilldoc`:
 * chỗ cần nó (ảnh `apm-file:`) nằm sâu ba tầng dưới chỗ biết nó.
 *
 * Vắng provider ⇒ "Tệp của tôi" — trang Tệp không phải làm gì.
 */
export interface PreviewSource {
  /** Tiền tố khoá cache: URL của hai nơi không được lẫn vào nhau. */
  readonly key: string;
  readonly downloadUrl: (fileId: string) => Promise<{ readonly url: string }>;
  readonly urlsOf: (
    fileIds: readonly string[],
  ) => Promise<Readonly<Record<string, string | null>>>;
}

export const MY_FILES_SOURCE: PreviewSource = {
  key: 'me',
  downloadUrl: (fileId) => myFilesApi.downloadUrl(fileId),
  urlsOf: (fileIds) => myFilesApi.urlsOf(fileIds),
};

const PreviewSourceContext = createContext<PreviewSource>(MY_FILES_SOURCE);

export const PreviewSourceProvider = PreviewSourceContext.Provider;

export function usePreviewSource(): PreviewSource {
  return useContext(PreviewSourceContext);
}
